(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[850],{

/***/ 35582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Meta; },
/* harmony export */   "s": function() { return /* binding */ OpenGraphType; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var lib_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22498);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // NOTE: copied from next-seo since it doesn't export this type.



var OpenGraphType;

(function (OpenGraphType) {
  OpenGraphType["WEBSITE"] = "website";
  OpenGraphType["ARTICLE"] = "article";
})(OpenGraphType || (OpenGraphType = {}));

var Meta = function Meta(_ref) {
  var titlePrefix = _ref.titlePrefix,
      _ref$titleSeparator = _ref.titleSeparator,
      titleSeparator = _ref$titleSeparator === void 0 ? '|' : _ref$titleSeparator,
      _ref$titleSuffix = _ref.titleSuffix,
      titleSuffix = _ref$titleSuffix === void 0 ? lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .SITE_NAME */ .px : _ref$titleSuffix,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? OpenGraphType.WEBSITE : _ref$type,
      description = _ref.description,
      _ref$seo = _ref.seo,
      seo = _ref$seo === void 0 ? {
    openGraph: {
      images: []
    }
  } : _ref$seo,
      _ref$relativeUrl = _ref.relativeUrl,
      relativeUrl = _ref$relativeUrl === void 0 ? '' : _ref$relativeUrl;
  var title = "".concat(titlePrefix, " ").concat(titleSeparator, " ").concat(titleSuffix);
  var url = "".concat("https://www.cutintothejamstack.com").concat(relativeUrl);

  var openGraph = _objectSpread({
    url: url,
    title: title,
    description: description,
    site_name: lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .SITE_NAME */ .px,
    type: type
  }, seo.openGraph);

  var twitter = _objectSpread({
    handle: '@mcavaliere',
    cardType: 'summary'
  }, seo.twitter);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, _objectSpread({
      title: title,
      description: description,
      openGraph: openGraph,
      twitter: twitter
    }, seo))
  });
};

/***/ }),

/***/ 34624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "rU": function() { return /* binding */ Link; }
/* harmony export */ });
/* unused harmony export Button */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40639);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73238);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children", "href"],
    _excluded2 = (/* unused pure expression or super */ null && (["children", "href"])),
    _excluded3 = ["children", "href"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var Link = function Link(_ref) {
  var children = _ref.children,
      href = _ref.href,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: href,
    passHref: true,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  });
};
var Button = function Button(_ref2) {
  var children = _ref2.children,
      href = _ref2.href,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx(NextLink, {
    href: href,
    passHref: true,
    children: /*#__PURE__*/_jsx(ChakraButton, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  });
};
var BreadcrumbLink = function BreadcrumbLink(_ref3) {
  var children = _ref3.children,
      href = _ref3.href,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: href,
    passHref: true,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .BreadcrumbLink */ .At, _objectSpread(_objectSpread({}, props), {}, {
      children: children
    }))
  });
};

/***/ }),

/***/ 79102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ MaxWidthContainer; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40639);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var MaxWidthContainer = function MaxWidthContainer(_ref) {
  var children = _ref.children,
      rest = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, _objectSpread(_objectSpread({
    maxW: "5xl",
    w: "100%"
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 80369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getLayout; }
/* harmony export */ });
/* unused harmony export MaxWidthContainerLayout */
/* harmony import */ var components_MaxWidthContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79102);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var MaxWidthContainerLayout = function MaxWidthContainerLayout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_MaxWidthContainer__WEBPACK_IMPORTED_MODULE_0__/* .MaxWidthContainer */ .a, {
    my: 20,
    children: children
  });
};
var getLayout = function getLayout(page) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MaxWidthContainerLayout, {
    children: page
  });
};

/***/ }),

/***/ 13932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ A; },
  "E": function() { return /* binding */ Code; },
  "H1": function() { return /* binding */ H1; },
  "H2": function() { return /* binding */ H2; },
  "H3": function() { return /* binding */ H3; },
  "H4": function() { return /* binding */ H4; },
  "H5": function() { return /* binding */ H5; },
  "H6": function() { return /* binding */ H6; },
  "HR": function() { return /* binding */ HR; },
  "LI": function() { return /* binding */ LI; },
  "OL": function() { return /* binding */ OL; },
  "P": function() { return /* binding */ P; },
  "UL": function() { return /* binding */ UL; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(40639);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/esm/prism.js + 15 modules
var prism = __webpack_require__(22557);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/cjs/styles/prism/index.js
var styles_prism = __webpack_require__(84283);
;// CONCATENATED MODULE: ./lib/shared/utils.ts
/**
 * Adapted from the markdown-toc utility, to parallel its functionality.
 *
 * @param string
 * @returns
 */
function slugify(string) {
  var str = string;
  str = str.toLowerCase();
  str = str.split(' ').join('-');
  str = str.split(/\t/).join('--');
  str = str.split(/<\/?[^>]+>/).join(''); // eslint-disable-next-line no-useless-escape

  str = str.split(/[|$&`~=\\\/@+*!?({[\]})<>=.,;:'"^]/).join('');
  str = str.split(/[。？！，、；：“”【】（）〔〕［］﹃﹄“ ”‘’﹁﹂—…－～《》〈〉「」]/).join('');
  return str;
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./lib/shared/contentRenderers.tsx

var _excluded = ["children"];






var P = function P(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
    as: "p",
    mb: 4,
    children: children
  });
};
var H1 = function H1(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h1",
    size: "2xl",
    mb: 5,
    id: slugify(children.toString()),
    children: children
  });
};
var H2 = function H2(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h2",
    size: "xl",
    mb: 3,
    id: slugify(children.toString()),
    children: children
  });
};
var H3 = function H3(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h3",
    size: "lg",
    mb: 3,
    id: slugify(children.toString()),
    children: children
  });
};
var H4 = function H4(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h4",
    size: "md",
    mb: 3,
    id: slugify(children.toString()),
    children: children
  });
};
var H5 = function H5(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h5",
    size: "sm",
    mb: 3,
    id: slugify(children.toString()),
    children: children
  });
};
var H6 = function H6(_ref7) {
  var children = _ref7.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h6",
    size: "xs",
    mb: 1,
    id: slugify(children.toString()),
    children: children
  });
};
var HR = function HR() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    mb: 4,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {})
  });
};
var Code = function Code(_ref8) {
  var _rest$className;

  var children = _ref8.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref8, _excluded);

  var language = ((_rest$className = rest.className) === null || _rest$className === void 0 ? void 0 : _rest$className.replace(/language-/, '')) || 'javascript';

  if (!rest.inline) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      mb: 4,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(prism/* default */.Z, {
        language: language,
        style: styles_prism/* okaidia */.be,
        children: children
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
    as: "code",
    color: "brand.red",
    children: children
  });
};
var OL = function OL(_ref9) {
  var children = _ref9.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* OrderedList */.GS, {
    mb: 3,
    children: children
  });
};
var UL = function UL(_ref10) {
  var children = _ref10.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* UnorderedList */.QI, {
    mb: 3,
    children: children
  });
};
var LI = function LI(_ref11) {
  var children = _ref11.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
    children: children
  });
};
var A = function A(_ref12) {
  var children = _ref12.children,
      href = _ref12.href;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: href,
    passHref: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
      textDecoration: "underline",
      children: children
    })
  });
}; // export const IMG = ({
//   src,
//   alt,
//   width,
//   height,
//   ...rest
// }: JSX.IntrinsicElements['img']) => {
//   return (
//     <Container position="relative">
//       <Image
//         src={src}
//         alt={alt}
//         layout="responsive"
//         width={width}
//         height={height}
//         {...rest}
//       />
//     </Container>
//   );
// };

/***/ }),

/***/ 60611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ PostPage; }
});

// NAMESPACE OBJECT: ./lib/shared/tocRenderers.tsx
var tocRenderers_namespaceObject = {};
__webpack_require__.r(tocRenderers_namespaceObject);
__webpack_require__.d(tocRenderers_namespaceObject, {
  "a": function() { return a; },
  "h1": function() { return h1; },
  "h2": function() { return h2; },
  "h3": function() { return h3; },
  "li": function() { return li; },
  "ul": function() { return ul; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(40639);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 126 modules
var react_markdown = __webpack_require__(73985);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/avatar/dist/index.esm.js
var dist_index_esm = __webpack_require__(3812);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/ArticleAuthor/index.tsx


var _excluded = ["date", "name"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var ArticleAuthor = function ArticleAuthor(_ref) {
  var date = _ref.date,
      name = _ref.name,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, _objectSpread(_objectSpread({
    marginTop: "2",
    spacing: "2",
    display: "flex",
    alignItems: "center"
  }, rest), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* Avatar */.qE, {
      borderRadius: "full",
      boxSize: "40px",
      src: "/mike.jpg"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      fontWeight: "normal",
      fontSize: "md",
      children: name
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      fontWeight: "normal",
      fontSize: "md",
      children: "\u2014"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      fontWeight: "normal",
      fontSize: "md",
      children: dayjs_min_default()(date).format('MM/D/YYYY')
    })]
  }));
};
// EXTERNAL MODULE: ./layouts/MaxWidthContainerLayout.tsx
var MaxWidthContainerLayout = __webpack_require__(80369);
// EXTERNAL MODULE: ./layouts/SiteOuterLayout.tsx + 66 modules
var SiteOuterLayout = __webpack_require__(61607);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/index.esm.js
var breadcrumb_dist_index_esm = __webpack_require__(73238);
// EXTERNAL MODULE: ./components/Link/index.tsx
var Link = __webpack_require__(34624);
;// CONCATENATED MODULE: ./components/ArticlesBreadcrumb/index.tsx




var ArticlesBreadcrumb = function ArticlesBreadcrumb() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(breadcrumb_dist_index_esm/* Breadcrumb */.aG, {
    mb: 3,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(breadcrumb_dist_index_esm/* BreadcrumbItem */.gN, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* BreadcrumbLink */.At, {
        href: "/",
        children: "Home"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(breadcrumb_dist_index_esm/* BreadcrumbItem */.gN, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* BreadcrumbLink */.At, {
        href: "/articles",
        children: "Articles"
      })
    })]
  });
};
// EXTERNAL MODULE: ./components/HeadContent/index.tsx
var HeadContent = __webpack_require__(35582);
;// CONCATENATED MODULE: ./layouts/ArticleLayout.tsx


function ArticleLayout_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ArticleLayout_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ArticleLayout_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ArticleLayout_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var ArticleLayout = function ArticleLayout(_ref) {
  var children = _ref.children,
      _ref$article = _ref.article,
      _ref$article$data = _ref$article.data,
      title = _ref$article$data.title,
      excerpt = _ref$article$data.excerpt,
      seo = _ref$article.seo;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeadContent/* Meta */.h, {
      titlePrefix: title,
      description: excerpt,
      seo: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArticlesBreadcrumb, {}), children]
  });
};
var getLayout = function getLayout(page, pageProps) {
  return (0,SiteOuterLayout/* getLayout */.G0)((0,MaxWidthContainerLayout/* getLayout */.G)( /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleLayout, ArticleLayout_objectSpread(ArticleLayout_objectSpread({}, pageProps), {}, {
    children: page
  }))));
};
ArticleLayout.getLayout = getLayout;
// EXTERNAL MODULE: ./lib/shared/contentRenderers.tsx + 1 modules
var contentRenderers = __webpack_require__(13932);
;// CONCATENATED MODULE: ./lib/shared/tocRenderers.tsx


var h1 = function h1(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
    fontWeight: "bold",
    children: children
  });
};
var h2 = function h2(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
    children: children
  });
};
var h3 = function h3(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
    children: children
  });
}; // NOTE: small hack. Convert ul to ol here, since there's no obvious way to get markdown-toc to generate ordered list items.

var ul = function ul(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* OrderedList */.GS, {
    m: 0,
    listStyleType: "none",
    children: children
  });
};
var li = function li(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
    fontWeight: "bold",
    color: "gray.600",
    sx: {
      '&': {
        borderBottomColor: 'gray.400',
        borderBottomStyle: 'solid',
        borderBottomWidth: '2px'
      },
      '&:last-of-type': {
        borderBottomWidth: '0px'
      },
      'a + ul > li:first-of-type, a + ol > li:first-of-type': {
        borderTopColor: 'gray.400',
        borderTopStyle: 'solid',
        borderTopWidth: '2px'
      }
    },
    children: children
  });
};
var a = function a(_ref6) {
  var children = _ref6.children,
      href = _ref6.href;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
    display: "block",
    color: "#2F7FDA",
    href: href,
    py: 4,
    _hover: {
      textDecoration: 'none'
    },
    sx: {
      '&:before': {
        color: 'gray.800',
        content: '"•"',
        fontSize: 'var(--chakra-fontSizes-xl)',
        marginRight: 'var(--chakra-space-1)'
      },
      'ul ul &, ol ol &': {
        paddingLeft: 'var(--chakra-space-5)'
      }
    },
    children: children
  });
};
;// CONCATENATED MODULE: ./pages/articles/[slug].tsx








var __N_SSG = true;
var components = {
  code: contentRenderers/* Code */.E,
  a: contentRenderers.A,
  p: contentRenderers.P,
  h1: contentRenderers.H1,
  h2: contentRenderers.H2,
  h3: contentRenderers.H3,
  h4: contentRenderers.H4,
  h5: contentRenderers.H5,
  h6: contentRenderers.H6,
  hr: contentRenderers.HR,
  ol: contentRenderers.OL,
  ul: contentRenderers.UL,
  li: contentRenderers.LI
};
function PostPage(_ref) {
  var _ref$article = _ref.article,
      content = _ref$article.content,
      _ref$article$data = _ref$article.data,
      date = _ref$article$data.date,
      title = _ref$article$data.title,
      toc = _ref$article.toc;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(contentRenderers.H1, {
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
      direction: "row",
      justify: "space-between",
      mb: 5,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArticleAuthor, {
        name: "Mike Cavaliere",
        date: date
      })
    }), toc && /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      p: 8,
      pb: 2,
      mb: 5,
      borderRadius: 15,
      borderColor: "gray.800",
      borderStyle: "solid",
      borderWidth: "2px",
      backgroundColor: "#F5F5F5",
      as: "nav",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        textTransform: "uppercase",
        fontWeight: "bold",
        color: "gray.800",
        mb: 3,
        children: "Table of Contents"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
        components: tocRenderers_namespaceObject,
        children: toc
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("article", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
        components: components,
        children: content
      })
    })]
  });
}
PostPage.getLayout = getLayout;

/***/ }),

/***/ 80617:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[slug]",
      function () {
        return __webpack_require__(60611);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [503,26,774,888,179], function() { return __webpack_exec__(80617); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);